export default __webpack_public_path__ + "static/media/h100-4.428daae6.png";